import { render, staticRenderFns } from "./FeaturesArea.vue?vue&type=template&id=7cfd777b&"
import script from "./FeaturesArea.vue?vue&type=script&lang=js&"
export * from "./FeaturesArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports